// The icon of a log line that no spell wrote: one solid shape for each type of
// thing the rules did. It sits where the circle of a spell sits, in a muted
// color, so every line starts with a mark.

import type { LogTone } from '../game/state';
import { svg } from '../lib/svg';

const ICON_BOX = 24;

type PlainTone = Exclude<LogTone, 'ally' | 'enemy' | 'any' | 'board'>;

/** An arrow, a cross, the outline of the die, a wheel face, an hourglass, and a dot. */
const ICONS: Record<PlainTone, string> = {
  move: 'M4 10 H13 V5 L21 12 L13 19 V14 H4 Z',
  capture:
    'M6.5 4 L12 9.5 L17.5 4 L20 6.5 L14.5 12 L20 17.5 L17.5 20 L12 14.5 L6.5 20 L4 17.5 L9.5 12 L4 6.5 Z',
  roll: 'M12 2 L21 12 L12 22 L3 12 Z',
  wheel: 'M4 4 H20 V20 H4 Z M8 8 V16 H16 V8 Z',
  timer: 'M5 3 H19 V6 L13.5 12 L19 18 V21 H5 V18 L10.5 12 L5 6 Z',
  system: 'M12 7 A5 5 0 1 0 12 17 A5 5 0 1 0 12 7 Z',
};

const isPlainTone = (tone: LogTone): tone is PlainTone => tone in ICONS;

/** A line a spell wrote in a polarity tone, with no spell on it, takes the dot. */
export const createLogToneIcon = (tone: LogTone): HTMLElement => {
  const mark = document.createElement('span');
  mark.className = 'chronicle__kind';
  mark.append(
    svg(
      'svg',
      { class: 'chronicle__glyph', viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`, 'aria-hidden': 'true' },
      [svg('path', { d: ICONS[isPlainTone(tone) ? tone : 'system'], 'fill-rule': 'evenodd' })],
    ),
  );
  return mark;
};
